// Маршрут страницы. Как в Nuxt, каждая страница видит «свой» маршрут: пока новая страница загружается,
// уходящая не получает чужих параметров и не запускает лишних запросов.
import { inject, type InjectionKey } from 'vue';
import { useRoute as useRouterRoute, type RouteLocationNormalizedLoaded } from 'vue-router';

export const pageRouteKey: InjectionKey<RouteLocationNormalizedLoaded> = Symbol('pageRoute');

export function useRoute(): RouteLocationNormalizedLoaded {
  return inject(pageRouteKey, null) ?? useRouterRoute();
}
